'use client'

import { useMenuStore } from '@/store/menu.slice'

/**
 * Checkbox ID that controls the mobile navigation menu state.
 */
export const MOBILE_NAVIGATION_MENU_STATE_ID = 'mobile-navigation-menu-cbx'

/**
 * Component that manages the state of the mobile navigation menu.
 * It uses a checkbox input to toggle the menu open and closed.
 * This approach allows for progressive enhancement, where the menu can be open without JavaScript.
 */
const MobileNavigationMenuState = () => {
  const { isOpen, toggle } = useMenuStore()

  return (
    <input
      type="checkbox"
      autoComplete="off"
      autoFocus={false}
      checked={isOpen}
      className="peer invisible hidden"
      id={MOBILE_NAVIGATION_MENU_STATE_ID}
      onChange={(e) => toggle(e.target.checked)}
    />
  )
}

export default MobileNavigationMenuState
